module.exports = __webpack_public_path__ + "static/media/icon_lock.3c452a29.svg";